type TAnalyticType = 'SessionRestored';

export const recordAnalytic = (type: TAnalyticType, data: Record<string, string | number>): void => {
  if (window.newrelic) {
    window.newrelic.addPageAction(type, data);
  }
}